// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { gql } from 'apollo-angular';

export const activeClaListQuery = gql`
  query activeClaList($input: ActiveClaListInput!) {
    activeClaList(input: $input) {
      projectId
      projectLogo
      projectName
      projectSfid
      projectType
      signatoryName
      signedOn
      claGroupName
      pdf
      subProjects
    }
  }
`;
